import FrameStore from '@/domains/Store/FrameStore'
import {ILeaderboardTeamItem} from '@/types/ws.types'
import AudioManager from '@repo/shared/AudioManager'
import clsx from 'clsx'
import {useAtomValue} from 'jotai'
import {useEffect, useRef, useState} from 'react'
import {totalPlayersState} from '../../Store/atoms'
import {TeamCount} from './components/TeamCount'

const audioManager = new AudioManager()
const fStore = new FrameStore()

export const ParticipantsCount = () => {
  const totalPlayers = useAtomValue(totalPlayersState)

  const [leaderboard, setLeaderboard] = useState<ILeaderboardTeamItem[]>([])

  const playersCountRef = useRef(0)

  useEffect(() => {
    if (totalPlayers > playersCountRef.current) {
      playersCountRef.current = totalPlayers

      audioManager.SFX.player_join?.play()
    }
  }, [totalPlayers])

  const updateParticipantsCount = () => {
    const leaderboardTeams = fStore.getLeaderboard()?.leaderboardTeams

    if (leaderboardTeams) {
      setLeaderboard(leaderboardTeams)
    }
  }

  const intervalTimer = useRef<NodeJS.Timeout | null>()
  useEffect(() => {
    intervalTimer.current = setInterval(updateParticipantsCount, 100)

    return () => {
      clearInterval(intervalTimer.current!)
    }
  }, [])

  if (!leaderboard.length) {
    return null
  }

  return (
    <div
      id="teams-counters"
      className={clsx(
        'absolute left-0 top-0',
        'w-fit min-w-6 rounded-3xl bg-[rgba(1,50,102,0.8)] p-[16px] text-center text-sm',
        'flex flex-col gap-[16px]',
      )}
    >
      {leaderboard.map((team, index) => (
        <TeamCount key={index} team={team} />
      ))}
    </div>
  )
}
